import { Circle, SquareProps } from '@cdl/heartbeat-react';
import React from 'react';

type Props = {
  children: React.ReactNode;
} & SquareProps;

export const CustomCircle: React.FC<Props> = ({ children, ...rest }) => {
  return (
    <Circle
      size='30px'
      bg='orange.400'
      border='1px'
      borderColor='white'
      color='white'
      {...rest}
    >
      {children}
    </Circle>
  );
};
